import React, { useCallback, useEffect, useMemo, useState } from 'react';

export const ThemeContext = React.createContext({});

export function StoreProvider({ children }) {
    const [isMultistore, setIsMultistore] = useState(true);
    const [multistores, setMultistores] = useState([]);
    const [selectedMultistore, setSelectedMultistore] = useState(null);

    useEffect(() => {
        const multistore = localStorage.getItem('multistore');
        setIsMultistore(JSON.parse(multistore));

        const stores = localStorage.getItem('multistore:stores');
        if (stores) setMultistores(JSON.parse(stores));
    }, []);

    const getMultistoreState = useCallback(() => isMultistore, [isMultistore]);

    const getStores = useCallback(() => multistores, [multistores]);

    const setStores = useCallback((stores) => {
        localStorage.setItem('multistore:stores', JSON.stringify(stores));
        setMultistores(stores);
    }, []);

    const setLastSelectedStore = useCallback((storeId) => {
        if (multistores && multistores.length && storeId) {
            const store = multistores.find((store) => store.id === storeId);
            setSelectedMultistore(store);
            localStorage.setItem('multistore:selectedStore', JSON.stringify(store));
        }
    }, [multistores]);

    const getInitialSelectedStore = useCallback(() => {
        let multistoreSelected = localStorage.getItem('multistore:selectedStore');
        if (!multistoreSelected || multistoreSelected === 'undefined') {
            return;
        }
        multistoreSelected = JSON.parse(multistoreSelected);
        setSelectedMultistore(multistoreSelected);
        return multistoreSelected;
    }, []);

    const setMultistoreState = useCallback((value) => {
        setIsMultistore(value);
    }, []);

    const storeValue = useMemo(
        () => ({
            isMultistore,
            multistores,
            selectedMultistore,
            getMultistoreState,
            setMultistoreState,
            setStores,
            getStores,
            setLastSelectedStore,
            getInitialSelectedStore
        }),
        [
            isMultistore,
            multistores,
            selectedMultistore,
            getMultistoreState,
            setMultistoreState,
            setStores,
            getStores,
            setLastSelectedStore,
            getInitialSelectedStore
        ],
    );

    return (
        <ThemeContext.Provider value={storeValue}>{children}</ThemeContext.Provider>
    );
}

export const useStore = () => React.useContext(ThemeContext);
